module.exports = __webpack_public_path__ + "static/media/p0202.4ce40fb8.png";